import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { EventIndicatorsQuery, EventIndicatorsQueryVariables } from '@/shared/api';
import EVENT_INDICATORS_QUERY from '../queries/eventIndicators';

/**
 * Loads the clinic events that drive the event indicators on the study list. Runs EVENT_INDICATORS_QUERY and throws the first GraphQL error message when clinicEvents is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The clinic events page.
 */
const fetchEventIndicators = async (
  filter: EventIndicatorsQueryVariables['filter'],
  limit = 10,
): Promise<EventIndicatorsQuery['clinicEvents']> => {
  const client = createClient();
  const eventIndicatorsResult = await client.query<
    EventIndicatorsQuery,
    EventIndicatorsQueryVariables
  >({
    query: EVENT_INDICATORS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = eventIndicatorsResult;
  const { clinicEvents } = data;
  if (_.isNil(clinicEvents) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicEvents;
};

export default fetchEventIndicators;
